// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".dialog-footer[data-v-0b9ef052] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n}\n.dialog-footer[data-v-0b9ef052]  .el-alert {\n  padding: 0;\n  background: transparent;\n  text-align: start;\n  line-height: 1;\n}", ""]);
// Exports
module.exports = exports;
